module.exports = "/_next/static/images/UnitePaidAndOwnedChannels@2x-38d3d44f43056d23bba285fbfd5f6a2c.png";